import { nextTick } from "vue";
import { getValuesFromIndexedDB, setValuesInIndexedDB } from "~/utils/idb.js";
import { sincronizzaTokenLocale } from "~/utils/tokenLocale.js";

// All'avvio allinea il cookie del token e IndexedDB (app/utils/tokenLocale.js): nell'app nativa
// il cookie si perde alla chiusura e torna da IndexedDB. Il setup è async e Nuxt lo aspetta:
// la navigazione iniziale, e con lei il middleware `auth.js` che legge il cookie, parte solo
// dopo che i plugin hanno finito. Il prefisso `01.` lo fa girare prima degli altri plugin.
export default defineNuxtPlugin(async () => {
  const cookie = useCookie(`token${useRuntimeConfig().public.base_progetto}`);

  try {
    await sincronizzaTokenLocale({
      cookie: {
        get: () => cookie.value,
        set: async (token) => {
          cookie.value = token;
          await nextTick(); // useCookie scrive document.cookie al flush del watcher
        },
      },
      idb: {
        get: async () => (await getValuesFromIndexedDB(["token"])).token,
        set: (token) => setValuesInIndexedDB({ token }),
      },
    });
  } catch (e) {
    // IndexedDB non disponibile (navigazione privata, spazio pieno): il cookie resta com'è e
    // l'app parte lo stesso, un plugin che lancia la fermerebbe.
    console.warn("[token-locale] allineamento del token non riuscito:", e);
  }
});
